import createApiClient from "./api";

const client = createApiClient();

export const api = {
  createNotificationTemplate: ({ orgId, payload }) =>
    client
      .post(`admin/org/${orgId}/notification-templates`, payload)
      .then(({ data }) => data),

  sendNotification: ({ orgId, notificationId }) =>
    client
      .post(`admin/org/${orgId}/notification-templates/${notificationId}`)
      .then(({ data }) => data),

  updateNotificationTemplate: ({ orgId, notificationId, payload }) =>
    client
      .patch(
        `admin/org/${orgId}/notification-templates/${notificationId}`,
        payload
      )
      .then(({ data }) => data),

  deleteNotificationTemplate: ({ orgId, notificationId }) =>
    client
      .delete(`admin/org/${orgId}/notification-templates/${notificationId}`)
      .then(({ data }) => data),

  getAllTemplates: ({
    orgId,
    search,
    perPage,
    currentPage,
    eventId,
    order,
    sortBy,
    dateScheduled
  }) =>
    client
      .get(
        `admin/org/${orgId}/notification-templates?search=${search}&perPage=${perPage}&page=${currentPage}
            &${eventId ? `trigger=${eventId}` : ""}
            &${sortBy ? `sortBy=${sortBy}` : ""}
            &${order ? `order=${order}` : ""}
            &${dateScheduled ? `dateScheduled=${dateScheduled}` : ""}`
      )
      .then(({ data }) => data),

  getNotificationSummary: ({ orgId, search, perPage, currentPage }) =>
    client
      .get(`admin/org/${orgId}/notification-templates/summary`)
      .then(({ data }) => data),

  getEventTriggers: () =>
    client.get(`admin/notification-triggers`).then(({ data }) => data),
};
